"use strict";

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.regexp.replace");

var _axios = _interopRequireDefault(require("axios"));

var _themeCurrency = require("@shopify/theme-currency");

var _utils = require("../helpers/utils");

var _cssClasses = _interopRequireDefault(require("../helpers/cssClasses"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

var Paperback = 'Paperback';
var subscriptionString = 'subscription';
var selectors = {
  productType: '[data-type]',
  productFormat: '[js-product-format]',
  productFormatHeader: '[js-product-format-header]',
  productSubscription: '[js-product-subscription]',
  productData: 'product',
  subscriptionInputs: '.product-form__subscription-inputs',
  optionSelector: '[js-product-form="optionSelector"]',
  subscriptionsGift: '[js-subscription="subscriptionsGift"]',
  subscriptionsGiftCheckbox: '[js-subscription="subscriptionsGiftCheckbox"]',
  subscriptionsTooltip: '[js-subscription="tooltip"]',
  subscriptionsTooltipCta: '[js-subscription="tooltipCta"]'
};

var formatButton = function formatButton(productType, index) {
  var buttonClass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var disabled = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var isSingleFormat = arguments.length > 4 ? arguments[4] : undefined;

  var singleFormat = function singleFormat() {
    return isSingleFormat ? 'subscription--swatch__format-single is-active' : buttonClass;
  };

  return "<button ".concat(disabled, " id=\"title-productvariantdrop-").concat(index, "\" class=\"subscription--swatch__button subscription--swatch__format swatch__button ").concat(singleFormat(), "\"  js-option-value=\"").concat(productType, "\" js-product-form=\"formatSelector\">").concat(productType, "</button>");
};

var subscriptionInputs = function subscriptionInputs(item) {
  var discountProductId = item.discountProductId,
      mainProductId = item.mainProductId,
      collectionId = item.collectionId,
      sellingPlanGroups = item.sellingPlanGroups;
  var sellingPlanId = sellingPlanGroups[0].selling_plans[0].id;
  return "\n    <input type=\"hidden\" name=\"selling_plan\" value=\"".concat(sellingPlanId, "\">\n    <input type=\"hidden\" name=\"properties[_discount_product_id]\" value=\"").concat(discountProductId, "\">\n    <input type=\"hidden\" name=\"properties[_main_product_id]\" value=\"").concat(mainProductId, "\">\n    <input type=\"hidden\" name=\"properties[_collection_id]\" value=\"").concat(collectionId, "\">\n  ");
};

var subscriptionError = function subscriptionError(type) {
  return "\n<li class=\"subscription--error\">\n  <div class=\"subscription--error\">\n    ".concat(theme.strings.product.noSubscriptions.replace('{{format}}', type), "\n  </div>\n</li>\n");
};

var _default = function _default() {
  var nodeSelectors = {
    productType: document.querySelector(selectors.productType),
    productFormat: document.querySelector(selectors.productFormat),
    productFormatHeader: document.querySelector(selectors.productFormatHeader),
    productSubscription: document.querySelector(selectors.productSubscription),
    subscriptionInputs: document.querySelector(selectors.subscriptionInputs),
    productData: document.getElementById(selectors.productData),
    subscriptionsGift: document.querySelector(selectors.subscriptionsGift),
    subscriptionsGiftCheckbox: document.querySelector(selectors.subscriptionsGiftCheckbox),
    subscriptionsTooltip: document.querySelector(selectors.subscriptionsTooltip),
    subscriptionsTooltipCta: document.querySelector(selectors.subscriptionsTooltipCta)
  };

  function downCase(stringValue) {
    return stringValue.toLowerCase();
  }

  function buildFormatButton(data, index, productsData) {
    var isOnLoad = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var isSingleFormat = arguments.length > 4 ? arguments[4] : undefined;
    var buttonSelector = '[js-product-form="formatSelector"]';
    var listItem = document.createElement('LI');
    listItem.classList.add('option');
    listItem.innerHTML = formatButton(data, index);
    nodeSelectors.productFormat.appendChild(listItem);

    if (isOnLoad && data === Paperback) {
      listItem.innerHTML = formatButton(data, index, _cssClasses["default"].active, 'disabled', isSingleFormat);
    } else {
      listItem.innerHTML = formatButton(data, index);
    }

    (0, _utils.on)('click', listItem, function (event) {
      event.preventDefault();
      buildFormatVariants(productsData[index].items, productsData[index].type);
      buildFormatInputs(productsData[index]);

      _toConsumableArray(document.querySelectorAll(buttonSelector)).forEach(function (item) {
        item.classList.remove(_cssClasses["default"].active);
        item.removeAttribute('disabled');
      });

      event.target.classList.add(_cssClasses["default"].active);
      event.target.setAttribute('disabled', 'disabled');
    });
    return listItem;
  }

  function getSubscriptionTitle(title) {
    var splitTitle = title.split('-');
    var sanitizedTitle = downCase(title);

    if (sanitizedTitle.indexOf('monthly') !== -1) {
      return "".concat(splitTitle[splitTitle.length - 2]);
    } else if (sanitizedTitle.indexOf('pre-paid') !== -1) {
      return "".concat(splitTitle[splitTitle.length - 3], "-").concat(splitTitle[splitTitle.length - 2]);
    }

    return '';
  }

  function buildFormatVariants(items, type) {
    var subscriptionOptions = '';

    if (items.length > 0) {
      items.forEach(function (item, index) {
        subscriptionOptions += buildSubscriptionButton(item, index);
      });
      nodeSelectors.productSubscription.innerHTML = subscriptionOptions;
      setSubscriptionInputs(items);
    } else {
      nodeSelectors.productSubscription.innerHTML = subscriptionError(type);
    }
  }
  /**
   * Build the subscription input buttons for the front-end.
   * @param {Object} item - Subscription product object
   * @param {Number} index - Index number
   * @returns {String} - Generated input HTML string.
   */


  function buildSubscriptionButton(item, index) {
    var title = item.title,
        discountVariantPrice = item.discountVariantPrice,
        discountPercent = item.discountPercent,
        discountMessage = item.discountMessage,
        mainVariantId = item.mainVariantId;
    var productTitle = getSubscriptionTitle(title);
    var isFirstItem = index === 0;
    var isChecked = isFirstItem ? 'checked="checked"' : '';
    var prePaidTitle = 'pre-paid';
    var productType = productTitle.toLowerCase().includes(prePaidTitle) ? 'pre-paid' : 'monthly';
    var productMessage = discountMessage === '' ? "".concat(theme.strings.product.saving, " ").concat(discountPercent, "%") : discountMessage;
    return "\n      <li class=\"option\" id=\"subscription-variant-".concat(index, "\">\n        <input\n          id=\"title-subscriptionvariantdrop-").concat(index, "\"\n          class=\"swatch__input subscription--swatch__input visually-hidden\"\n          name=\"id\"\n          value=\"").concat(mainVariantId, "\"\n          type=\"radio\"\n          ").concat(isChecked, "\n          js-option-value=\"paperback\"\n          js-product-form=\"optionSelector\"\n          data-subscription-type=\"").concat(productType, "\"\n        >\n        <label class=\"subscription--swatch__label\" for=\"title-subscriptionvariantdrop-").concat(index, "\">\n          <div class=\"subscription--swatch__button\">\n            <div class=\"subscription--title\">").concat(productTitle, "</div>\n            <div class=\"subscription--values\">\n              <div class=\"subscription--price\">\n                ").concat((0, _themeCurrency.formatMoney)(discountVariantPrice, theme.moneyFormat), "\n              </div>\n              <div class=\"subscription--discount\">").concat(productMessage, "</div>\n            </div>\n          </div>\n        </label>\n      </li>\n    ");
  }

  function setSubscriptionInputs(items) {
    items.forEach(function (item, index) {
      var subscriptionInput = document.getElementById("subscription-variant-".concat(index));
      (0, _utils.on)('click', subscriptionInput, function () {
        toggleGift(subscriptionInput);
        nodeSelectors.subscriptionInputs.innerHTML = subscriptionInputs(item);
      });
    });
  }

  function toggleGift(target) {
    var targetData = target.querySelector(selectors.optionSelector).dataset;

    if (targetData.subscriptionType === 'pre-paid') {
      nodeSelectors.subscriptionsGiftCheckbox.disabled = false;
      nodeSelectors.subscriptionsGift.classList.remove(_cssClasses["default"].disabled);
      return;
    }

    nodeSelectors.subscriptionsGiftCheckbox.checked = false;
    nodeSelectors.subscriptionsGiftCheckbox.disabled = true;
    nodeSelectors.subscriptionsGift.classList.add(_cssClasses["default"].disabled);
  }

  function createSubscriptionSelectors(data) {
    var isOnLoad = true;
    var paperback = data.filter(function (item) {
      return downCase(item.productType) === downCase(Paperback);
    });
    var sortedPaperbacks = sortSubscriptionItems(paperback);
    var products = [{
      type: Paperback,
      items: sortedPaperbacks
    }];
    var isSingleFormat = products.length === 1;

    if (isSingleFormat) {
      nodeSelectors.productFormatHeader.style.display = 'none';
    }

    products.forEach(function (item, index) {
      buildFormatButton(item.type, index, products, isOnLoad, isSingleFormat);
    }); // Set onload state

    buildFormatInputs(products[0]);
  }

  function sortSubscriptionItems(items) {
    var sortedItems = items.sort(function (keyA, keyB) {
      var itemAPrice = parseInt(keyA.discountVariantPrice, 10);
      var itemBPrice = parseInt(keyB.discountVariantPrice, 10);
      return itemAPrice - itemBPrice;
    });
    return sortedItems;
  }

  function buildFormatInputs(product) {
    // build paperback variants on page load
    var items = product.items,
        type = product.type;

    if (items.length > 0) {
      buildFormatVariants(items, type);
      nodeSelectors.subscriptionInputs.innerHTML = subscriptionInputs(product.items[0]);
    }
  }

  function getSubscriptionProducts(productTitle, bookCount) {
    _axios["default"].get("/search?type=product&q=title:\"".concat(productTitle, "\"&view=subscriptions"), {
      headers: {
        Accept: 'application/json'
      }
    }).then(function (response) {
      // Try parsing response.data if it's a string
      var data = response.data;

      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch (error) {
          data = [];
        }
      } // Ensure data is an array


      data = Array.isArray(data) ? data : [];
      var subscriptionProductsFilteredByBookCount = data.filter(function (product) {
        return product.title.includes("".concat(bookCount, " Books"));
      });
      createSubscriptionSelectors(subscriptionProductsFilteredByBookCount);
      return response;
    })["catch"](function (error) {
      window.console.error(error);
      return error;
    });
  }

  function getSubscriptionBookCount(data) {
    return data.tags.filter(function (tag) {
      return tag.indexOf('book-count') !== -1;
    })[0].split(':')[1].replace(/\s/g, '');
  }

  function setEventsListeners() {
    var tooltipCtas = [nodeSelectors.subscriptionsTooltipCta, nodeSelectors.subscriptionsTooltip];
    tooltipCtas.forEach(function (ctaElement) {
      (0, _utils.on)('click', ctaElement, function (event) {
        event.preventDefault();
        nodeSelectors.subscriptionsTooltip.classList.toggle(_cssClasses["default"].hidden);
      });
    });
  }

  function init() {
    var productJSON = JSON.parse(nodeSelectors.productData.innerHTML);
    var productTitle = productJSON.title;
    var dataType = downCase(productJSON.type);
    var bookCount = getSubscriptionBookCount(productJSON);

    if (dataType === subscriptionString) {
      getSubscriptionProducts(productTitle, bookCount);
    }

    setEventsListeners();
  }

  return Object.freeze({
    init: init
  });
};

exports["default"] = _default;